import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faAngleDown,
  faArrowAltCircleDown,
  faArrowAltCircleUp,
  faArrowsAltV,
  faBars,
  faBold,
  faBrowser,
  faCaretLeft,
  faCaretRight,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClock,
  faCloudUploadAlt,
  faDatabase,
  faEnvelope,
  faExclamationTriangle,
  faImage,
  faInfoCircle,
  faItalic,
  faLink,
  faMinusCircle,
  faMobile,
  faPaperPlane,
  faPauseCircle,
  faPlayCircle,
  faPlusCircle,
  faQuestionCircle,
  faSave,
  faSortDown,
  faSortUp,
  faSquare,
  faStrikethrough,
  faTable,
  faTimes,
  faTimesCircle,
  faUnderline,
  faUnlink,
  faUserFriends as fasUserFriends,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faAddressCard,
  faCamera,
  faClone,
  faComments,
  faCopy,
  faEye,
  faFileExcel,
  faFileWord,
  faHistory,
  faImagePolaroid,
  faMehBlank,
  faPen,
  faPrint,
  faSignOutAlt,
  faSortAmountDownAlt,
  faToggleOff,
  faToggleOn,
  faTrash,
  faUser,
  faUserFriends as fadUserFriends,
  faUserTie,
} from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAngleDown,
  faAddressCard,
  faArrowAltCircleDown,
  faArrowAltCircleUp,
  faArrowsAltV,
  faBars,
  faBold,
  faBrowser,
  faCamera,
  faCaretLeft,
  faCaretRight,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClock,
  faClone,
  faCloudUploadAlt,
  faComments,
  faCopy,
  faDatabase,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFileExcel,
  faFileWord,
  faHistory,
  faImage,
  faImagePolaroid,
  faInfoCircle,
  faItalic,
  faLink,
  faMehBlank,
  faMinusCircle,
  faMobile,
  faPaperPlane,
  faPauseCircle,
  faPen,
  faPlayCircle,
  faPlusCircle,
  faPrint,
  faQuestionCircle,
  faSave,
  faSignOutAlt,
  faSortAmountDownAlt,
  faSortDown,
  faSortUp,
  faSquare,
  faStrikethrough,
  faTable,
  faTimes,
  faTimesCircle,
  faToggleOff,
  faToggleOn,
  faTrash,
  faUnderline,
  faUnlink,
  faUser,
  fadUserFriends,
  fasUserFriends,
  faUserTie,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)